import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { CompanyEnrichType } from "@/enum/company-enrich-type.enum";

interface CompanyEnrichModeSelectorProps {
	mode: CompanyEnrichType;
	onChange: (mode: CompanyEnrichType) => void;
}

const MODES: { value: CompanyEnrichType; labelKey: string }[] = [
	{ value: CompanyEnrichType.SEARCH, labelKey: "modeSearch" },
	{ value: CompanyEnrichType.LOOK_A_LIKE, labelKey: "modeLookalike" },
	{ value: CompanyEnrichType.NEW_IN_ROLE, labelKey: "modeNewInRole" },
];

export const CompanyEnrichModeSelector: FunctionComponent<CompanyEnrichModeSelectorProps> = ({
	mode,
	onChange,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`companyEnrich.${key}`);

	return (
		<div className="flex flex-row gap-4 w-full flex-wrap">
			{MODES.map(({ value, labelKey }) => (
				<div key={value} className="w-auto">
					<Button
						color={mode === value ? ButtonColor.ACTION : ButtonColor.ACTION_SECONDARY}
						size={ButtonSize.ML}
						testId={`mode-${value}`}
						title={ts(labelKey)}
						onClick={() => onChange(value)}
					/>
				</div>
			))}
		</div>
	);
};
